import React, { useState } from 'react';
import { Modal, Button, message } from 'antd';
import { deleteUser } from '../../utils/services/userAPI';
import { deleteTeam } from '../../utils/services/teamsAPI';
import { ModalBody, Container } from './styles';
import { withTranslation } from 'react-i18next';
import { DELETE_USER_MODAL as deleteUserTrans, DELETE_TEAM_MODAL as deleteTeamTrans } from './translationValues';

const NAMESPACES = ['DELETE_USER_MODAL', 'DELETE_TEAM_MODAL'];

const DELETE_USER_MODAL = 'DELETE_USER_MODAL';
const DELETE_TEAM_MODAL = 'DELETE_TEAM_MODAL';

const DeleteUserModal = props => {
  const { visible, onCancel, targetUser, isDeleteTeam, t } = props;
  const [deleting, setDeleting] = useState(false);
  const onDelete = () => {
    const payload = {
      id: targetUser.id,
    };
    deleteAddedUser(payload);
  };

  const deleteAddedUser = async payload => {
    setDeleting(true);
    let deletionResponse;
    if (isDeleteTeam) {
      deletionResponse = await deleteTeam(payload);
      setDeleting(false);
      if (deletionResponse && deletionResponse.status) {
        if (deletionResponse.status === 'ResourceGroup Deleted Successfully') {
          message.success(t(deleteTeamTrans.TEAM_DELETED_MESSAGE.key, deleteTeamTrans.TEAM_DELETED_MESSAGE.value));
          onCancel(true);
        } else {
          deletionResponse.errors[0].code === 795 && 
          message.error(t(deleteTeamTrans.TEAM_UTILIZED_ERROR_MESSAGE.key, deleteTeamTrans.TEAM_UTILIZED_ERROR_MESSAGE.value));
          onCancel(false);
        }
      }
    } else {
      deletionResponse = await deleteUser(payload);
      setDeleting(false);
      if (deletionResponse && deletionResponse.errors && deletionResponse.errors.length === 0) {
        message.success(t(deleteUserTrans.USER_DELETED_MESSAGE.key, deleteUserTrans.USER_DELETED_MESSAGE.value));
        onCancel(true);
      }
    }
  };

  return (
    <Container onKeyDown={e => e.stopPropagation()}>
      <Modal
        title={isDeleteTeam ? t(`${DELETE_TEAM_MODAL}: ${deleteTeamTrans.TITLE.key}`, deleteTeamTrans.TITLE.value) 
        : t(`${DELETE_USER_MODAL}: ${deleteUserTrans.TITLE.key}`, deleteUserTrans.TITLE.value)}
        centered
        visible={visible}
        width="625px"
        onCancel={() => onCancel(false)}
        footer={[
          <Button key="back" onClick={() => onCancel(false)}>
            { isDeleteTeam ? t(`${DELETE_TEAM_MODAL}: ${deleteTeamTrans.CANCEL_BUTTON.key}`, deleteTeamTrans.CANCEL_BUTTON.value)
            : t(`${DELETE_USER_MODAL}: ${deleteUserTrans.CANCEL_BUTTON.key}`, deleteUserTrans.CANCEL_BUTTON.value)}
          </Button>,
          <Button key="submit" type="primary" loading={deleting} onClick={onDelete}>
            {isDeleteTeam
              ? deleting
                ? t(`${DELETE_TEAM_MODAL}: ${deleteTeamTrans.DELETING_BUTTON.key}`, deleteTeamTrans.DELETING_BUTTON.value)
                : t(`${DELETE_TEAM_MODAL}: ${deleteTeamTrans.DELETE_BUTTON.key}`, deleteTeamTrans.DELETE_BUTTON.value)
              : deleting
              ? t(`${DELETE_USER_MODAL}: ${deleteUserTrans.DELETING_BUTTON.key}`, deleteUserTrans.DELETING_BUTTON.value)
              : t(`${DELETE_USER_MODAL}: ${deleteUserTrans.DELETE_BUTTON.key}`, deleteUserTrans.DELETE_BUTTON.value)}
          </Button>,
        ]}
        className="warning-modal"
      >
        <ModalBody>
          <div className="warning-text">
            <span>{ isDeleteTeam ? t(
            `${DELETE_TEAM_MODAL}: ${deleteTeamTrans.DELETE_MESSAGE.key}`, 
            deleteTeamTrans.DELETE_MESSAGE.value)
            : t(`${DELETE_USER_MODAL}: ${deleteUserTrans.DELETE_MESSAGE.key}`, 
              deleteUserTrans.DELETE_MESSAGE.value)}</span>
            {targetUser && (
              <span className="text-highlighter">
                {isDeleteTeam
                  ? targetUser.name
                  : targetUser.aType === 'ad'
                  ? targetUser.displayName
                  : targetUser?.firstName ?? '' + ' ' + targetUser?.lastName ?? ''}
              </span>
            )}
            <span>?</span>
          </div>
        </ModalBody>
      </Modal>
    </Container>
  );
};
export default withTranslation(NAMESPACES)(DeleteUserModal);
